import _ from 'lodash'
import { BotFeatures } from '@feedyou-ai/feedbot-schema'
import aiStepSchema from '@feedyou/schema/schema/steps/ai.json'
import { AnyObject } from '@feedyou/utils'

import {
  removeConditionPropsFromSchema,
  useBaseStepSchema
} from '../../../../../../features/schema'
import { useIsStandaloneKbEnabled } from '../../../../../../features/knowledgeBase/hooks'

export function useFormSchema(sdkFeatures: BotFeatures[] = []) {
  const schema = useBaseStepSchema(aiStepSchema, sdkFeatures)
  const isStandaloneKbEnabled = useIsStandaloneKbEnabled()

  const adjusted = removeConditionPropsFromSchema(
    addLoopControlledRespondBeforeFirstInput(schema),
    sdkFeatures
  )

  if (!isStandaloneKbEnabled) {
    return { ...adjusted, properties: _.omit(adjusted.properties, 'knowledgeBases') }
  }

  return adjusted
}

export function addLoopControlledRespondBeforeFirstInput(schema: AnyObject) {
  const anyOf = schema?.properties?.input?.items?.anyOf

  if (!Array.isArray(anyOf)) {
    return schema
  }

  const adjustedAnyOf = anyOf.map((itemSchema: AnyObject) => {
    if (itemSchema?.properties?.type?.const !== 'wait-for-user-input') {
      return itemSchema
    }

    const respondBeforeFirstInputSchema = itemSchema?.properties?.respondBeforeFirstInput

    if (!itemSchema?.properties || !respondBeforeFirstInputSchema) {
      return itemSchema
    }

    const { respondBeforeFirstInput, ...properties } = itemSchema.properties

    return {
      ...itemSchema,
      properties,
      allOf: [
        ...(Array.isArray(itemSchema.allOf) ? itemSchema.allOf : []),
        {
          if: { properties: { loopUntilToolCall: { const: true } } },
          then: {
            properties: {
              respondBeforeFirstInput: respondBeforeFirstInputSchema
            }
          }
        }
      ]
    }
  })

  return {
    ...schema,
    properties: {
      ...schema.properties,
      input: {
        ...schema.properties.input,
        items: {
          ...schema.properties.input.items,
          anyOf: adjustedAnyOf
        }
      }
    }
  }
}
